import {Input} from "../../../basic/input";
import {Label} from "../../../basic/label";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";
import {useGetTeamsQuery} from "../../../../store/generated/api";

interface TeamSelectorProps {
    value: string;
    onChange: (value: string) => void;
    error?: string;
}

export function TeamSelector({value, onChange, error}: TeamSelectorProps) {
    const {t} = useTranslationWithKeys();

    const {data: teamsData, isLoading} = useGetTeamsQuery({
        page: 0,
        size: 1, // Only need to check if team exists, minimal data
        search: value // Search by the entered team ID to validate it exists (or not?)
    });

    const teamExists = value && teamsData?.teams?.length > 0;
    const showValidationError = value && !teamExists && !isLoading;

    return (
        <div className="space-y-2">
            <Label htmlFor="teamId">{t('admin.licenses.createLicenseDialog.teamId')} *</Label>
            <Input
                id="teamId"
                type="text"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={t('admin.licenses.createLicenseDialog.enterTeamId')}
                className={showValidationError ? "border-red-500" : ""}
            />
            {showValidationError && (
                <p className="text-sm text-red-500">
                    {t('admin.licenses.createLicenseDialog.errors.teamNotFound')}
                </p>
            )}
            {error && (
                <p className="text-sm text-red-500">
                    {error}
                </p>
            )}
        </div>
    );
}